import { VectorTileLayer } from '@deck.gl/carto'

/**
 * VectorTileLayer with two harmless-but-noisy upstream warnings silenced:
 *
 * - `@deck.gl/carto`'s `getLoadOptions()` hardcodes the legacy
 *   `gis: { format: 'binary' }` load option, which loaders.gl 4 reports as
 *   deprecated on every tile parse. It is replaced here with the modern
 *   equivalent `mvt: { shape: 'binary' }`.
 * - MVTLayer warns "renderSubLayers() must return GeoJsonLayer when using
 *   binary:true" whenever the `renderSubLayers` prop returns an array, even
 *   when every element is a binary-capable GeoJsonLayer (our POI layers
 *   return buffer + point sublayers). `state.binary` is only read by that
 *   warning during the synchronous super call, so it is masked around it.
 */
export class QuietVectorTileLayer extends VectorTileLayer {
  getLoadOptions() {
    const loadOptions = {
      ...super.getLoadOptions(),
    } as Record<string, unknown>
    delete loadOptions.gis
    return {
      ...loadOptions,
      mvt: { ...(loadOptions.mvt as object), shape: 'binary' },
    }
  }

  renderSubLayers(props: Parameters<VectorTileLayer['renderSubLayers']>[0]) {
    const state = this.state as { binary?: boolean }
    const binary = state.binary
    state.binary = false
    try {
      return super.renderSubLayers(props)
    } finally {
      state.binary = binary
    }
  }
}

QuietVectorTileLayer.layerName = 'QuietVectorTileLayer'
